export const environment = {
  production: true,
  enableLogs: false,
  API: '/apigee-url-replace/carbon_credit_negotiation/v1/',
  clientId: 'client_id_apigee',
};
